define(
    'BTM.BrowserCompatibility.BrowserCompatibility'
    , [
        'BTM.BrowserCompatibility.BrowserCompatibility.View',
        'SC.Configuration'
    ]
    , function (
        BrowserCompatibilityView,
        Configuration
    ) {
        'use strict';

        return {
            mountToApp: function mountToApp(container) {
                if (!Configuration.get('browserCompatibility.enabled')) {
                    return;
                }

                var unknownBrowserMessage = Configuration.get('browserCompatibility.supportedBrowserPage', 'We detected that the browser you are using is not fully functional, please click the button below to see the details of the supported browsers.');
                var unsupportedBrowserMessage = Configuration.get('browserCompatibility.unsupportedBrowserMessage', 'You are using $(0) browser, version $(1). This version does not support full functionality. please click the button below to see the details of the supported browsers.');
                var supportedBrowserPage = Configuration.get('browserCompatibility.supportedBrowserPage');
                var configs = {
                    unknownBrowserMessage: unknownBrowserMessage,
                    unsupportedBrowserMessage: unsupportedBrowserMessage,
                    supportedBrowserPage: supportedBrowserPage
                };

                var chromeVersion = Configuration.get('browserCompatibility.minimumChromeVersion') || 0;
                var firefoxVersion = Configuration.get('browserCompatibility.minimumFirefoxVersion') || 0;
                var ieVersion = Configuration.get('browserCompatibility.minimumIEVersion') || 0;
                var edgeVersion = Configuration.get('browserCompatibility.minimumEdgeVersion') || 0;
                var safariVersion = Configuration.get('browserCompatibility.minimumSafariVersion') || 0;
                var operaVersion = Configuration.get('browserCompatibility.minimumOperaVersion') || 0;

                var browsers = {
                    chrome: {
                        name: 'Chrome',
                        version: chromeVersion
                    },
                    firefox: {
                        name: 'Firefox',
                        version: firefoxVersion
                    },
                    msie: {
                        name: 'MS Internet Explorer',
                        version: ieVersion
                    },
                    edg: {
                        name: 'MS Edge',
                        version: edgeVersion
                    },
                    safari: {
                        name: 'Safari',
                        version: safariVersion
                    },
                    opr: {
                        name: 'Opera',
                        version: operaVersion
                    },
                }

                var layout = container.getComponent('Layout');
                if (layout) {
                    layout.addChildView('Header.Logo', function () {
                        return new BrowserCompatibilityView({container: container, browsers: browsers, configs: configs});
                    });
                }
            }
        };
    });
